<template>
  <div class="modal skin-modal">
    <div class="overlay" @click="$emit('closeSaleSkinModal')"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$emit('closeSaleSkinModal')"
        src="./../assets/close.svg"
      />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">Sell Your Skin</div>
              <div class="form-fields-wrapper">
                <div class="input-container">
                  <div class="desc">Skin name:</div>
                  <input type="text" placeholder="Skin name" v-model="title" />
                </div>
                <div class="input-container">
                  <div class="desc">Desired price:</div>
                  <input
                    type="text"
                    placeholder="Desired price"
                    v-model="price"
                    @input="allowOnlyNumbers"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Quality:</div>
                  <Select2
                    class="select2 single"
                    v-model="quality"
                    :options="qualityOptions"
                    @select="selectQuality($event)"
                    placeholder="Quality"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Steam inventory link to skin:</div>
                  <input
                    type="url"
                    placeholder="Steam inventory link to skin"
                    v-model="item_url"
                  />
                </div>
              </div>
              <div class="buttons">
                <button
                  class="button"
                  type="button"
                  @click="$emit('closeSaleSkinModal')"
                >
                  <span>Cancel</span>
                </button>
                <button
                  class="button"
                  type="button"
                  @click="create"
                  :disabled="!isFormValid"
                >
                  <span>Send</span>
                </button>
              </div>
              <transition name="fade">
                <div class="desc red" v-if="error">
                  {{ error }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";

export default {
  name: "SaleSkinModal",
  props: [],
  components: {
    Select2,
  },
  data: function () {
    return {
      title: "",
      price: "",
      quality: "",
      item_url: "",
      error: "",
      qualityOptions: [
        "Field-Tested",
        "Minimal Wear",
        "Battle-Scarred",
        "Well-Worn",
        "Factory New",
        "Not Painted",
      ],
    };
  },
  computed: {
    isFormValid() {
      return this.title && this.price && this.quality && this.item_url;
    },
  },
  methods: {
    allowOnlyNumbers() {
      this.price = this.price.replace(/[^0-9.,]/g, "");

      // Split the input into integer and decimal parts
      const parts = this.price.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      // Limit decimal part to two digits
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      // Concatenate the integer and decimal parts back
      this.price =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    selectQuality(event) {
      this.quality = event.text;
    },
    create() {
      if (!this.isFormValid) {
        this.error = "Please fill in all fields";
        return;
      }

      this.error = "";
      let data = {
        title: this.title,
        price: this.price,
        quality: this.quality,
        item_url: this.item_url,
        currency: this.$parent.currency,
      };

      this.$http
        .post(process.env.VUE_APP_API + "offer/create", data)
        .then((res) => {
          if (res.data.status === "OK") {
            this.$emit("closeSaleSkinModal");
            this.$parent.getOfferHistory(); // Refresh offer history
          } else {
            this.error = res.data.message || "An error occurred";
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          } else if (res.response && res.response.data) {
            if (res.response.data.errors) {
              // Handle validation errors
              const errors = res.response.data.errors;
              const errorMessages = Object.values(errors).flat();
              this.error = errorMessages.join(", ");
            } else if (res.response.data.message) {
              this.error = res.response.data.message;
            } else {
              this.error = "An error occurred";
            }
          } else {
            this.error = "An error occurred";
          }
        });
    },
  },
};
</script>

<style scoped>
.skin-modal .wrapper .form-fields-wrapper {
  display: flex;
  flex-direction: column;
  align-items: start;
}
.skin-modal .desc {
  width: 130px;
  text-align: left;
}
.skin-modal .input-container {
  padding-left: 0 !important;
  justify-content: start !important;
}
.skin-modal .input-container input {
  width: 238px;
  height: 50px;
}
.buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-top: 30px;
}
::v-deep(.select2) .select2-container {
  text-align: left;
}
.modal .button {
  margin-top: 0;
}
@media screen and (max-width: 768px) {
  .input-container .desc {
    width: fit-content !important;
  }
  .modal .wrapper .form input {
    margin-top: 0;
  }
  .input-container {
    flex-direction: column;
    align-items: start;
  }

  .buttons {
    flex-direction: column;
  }
}
</style>
